/**
 * Is a workflow run an Annual Review? (Sept 2026) Templates carry no "type",
 * so this looks at the run's template snapshot for a task that approves AR
 * documents (completion.approval.documentType 'ar'), falling back to the
 * template name as arWorkflowRollout.cjs does. Offering the AR SOA / ROA
 * documents is NOT a signal — New Documents rounds offer them too. Ad hoc runs
 * never count.
 *
 * CommonJS on purpose, like src/utils/workflowFirmRoles.js: the web bundle
 * (Recommendations AR mode, the "Due for AR booking" client filter) and the
 * server (workflow engine) both require it.
 */

function str(value) {
  return value == null ? '' : String(value).trim();
}

function runTasks(run) {
  const snapshot = run && run.templateSnapshot;
  return snapshot && Array.isArray(snapshot.tasks) ? snapshot.tasks : [];
}

function isAnnualReviewRun(run) {
  if (!run || typeof run !== 'object' || run.adHoc === true) return false;
  const approvesArDocuments = runTasks(run).some((task) => (
    task && task.completion && task.completion.approval && task.completion.approval.documentType === 'ar'
  ));
  if (approvesArDocuments) return true;
  return /annual\s*review/i.test(str(run.templateName || run.name));
}

function hasActiveAnnualReviewRun(runs) {
  return (Array.isArray(runs) ? runs : []).some((run) => run && run.status === 'active' && isAnnualReviewRun(run));
}

/** Approval document types of the Amendments page (src/utils/adviceScenarioDocuments.js). */
const NEW_DOCUMENTS_APPROVAL_TYPES = ['documents', 'roa-eo'];

/**
 * Is a workflow run a New Documents (ROA/EO) round? A task approves Amendments
 * documents, else the template name says so. Ad hoc runs never count.
 */
function isNewDocumentsRun(run) {
  if (!run || typeof run !== 'object' || run.adHoc === true) return false;
  const approvesNewDocuments = runTasks(run).some((task) => (
    task && task.completion && task.completion.approval
    && NEW_DOCUMENTS_APPROVAL_TYPES.indexOf(task.completion.approval.documentType) !== -1
  ));
  if (approvesNewDocuments) return true;
  return /new\s*documents/i.test(str(run.templateName || run.name));
}

module.exports = {
  isAnnualReviewRun,
  hasActiveAnnualReviewRun,
  isNewDocumentsRun,
};
